module.exports = require("dompurify");


//////////////////
// WEBPACK FOOTER
// external "dompurify"
// module id = 645
// module chunks = 0